import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, saveAuth, clearAuth, getStoredUser } from "./api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("hc_token")) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("hc_user", JSON.stringify(data));
    } catch {
      clearAuth();
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signup = async (email, password, name) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/signup", { email, password, name });
      saveAuth(data.token, data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      saveAuth(data.token, data.user);
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = () => { clearAuth(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, signup, login, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
